/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsImportersZql: {
  name: 'importers-zql';
  data: string;
} = {
  name: 'importers-zql',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 1 0 0-2H5a1 1 0 0 1-1-1v-7h16v1a1 1 0 1 0 2 0V5a3 3 0 0 0-3-3H5Zm15 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5h16Zm-7-4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm3.707 9.293a1 1 0 0 0-1.414 1.414L18.586 20H17a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v1.586l-3.293-3.293Z" fill="currentColor"/></svg>`,
};
